import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { loginAbsoluteRoute, userEntryRoute } from '@shared/shared-routes';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(private router: Router, private authentication: AuthenticationService) {}

  public canActivate(): Observable<boolean | UrlTree> {
    return this.authentication.isAuthenticated().pipe(
      map((authenticated) => {
        if (authenticated) {
          return true;
        } else {
          // Store the full URL path without the leading slash for proper navigation
          const currentPath = window.location.pathname + window.location.search;
          const redirectPath = currentPath.startsWith('/') ? currentPath.substring(1) : currentPath;
          localStorage.setItem('redirectUrl', redirectPath);

          // DDQ invite links for first-time users include uidb64+token.
          // Send them directly to password creation instead of login.
          const searchParams = new URLSearchParams(window.location.search);
          const uidb64 = searchParams.get('uidb64');
          const token = searchParams.get('token');

          if (uidb64 && token) {
            return this.router.parseUrl(
              `/${userEntryRoute}/reset/${encodeURIComponent(uidb64)}/${encodeURIComponent(token)}`
            );
          }

          return this.router.parseUrl(loginAbsoluteRoute);
        }
      }),
      first(),
    );
  }

  public canLoad(): Observable<boolean> {
    return this.authentication.isAuthenticated().pipe(
      map((authenticated) => {
        if (authenticated) {
          return true;
        }

        const currentPath = window.location.pathname + window.location.search;
        const redirectPath = currentPath.startsWith('/') ? currentPath.substring(1) : currentPath;
        localStorage.setItem('redirectUrl', redirectPath);

        const searchParams = new URLSearchParams(window.location.search);
        const uidb64 = searchParams.get('uidb64');
        const token = searchParams.get('token');

        if (uidb64 && token) {
          this.router.navigateByUrl(`/${userEntryRoute}/reset/${encodeURIComponent(uidb64)}/${encodeURIComponent(token)}`);
          return false;
        }

        this.router.navigate([loginAbsoluteRoute]);
        return false;
      }),
      first(),
    );
  }
}
